export default __webpack_public_path__ + "static/GT-Super-Display-Regular-54431a75f18a9c75c91cf2ac963b9200.woff";